import { InvoicedTripsValue } from '../../constants';
import { setFilterInvoicedTrips } from '../../trip.slice';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { RadioGroupFilterPopover } from 'src/common/primitives/FilterPopover/RadioGroupFilterPopover';

interface InvoiceColumnFilterProps {
  open: boolean;
  onClose: () => void;
}

export function InvoiceColumnFilter({
  open,
  onClose,
}: InvoiceColumnFilterProps) {
  const dispatch = useAppDispatch();

  const filterInvoicedTrips = useAppSelector(
    (state) => state.trip.filterInvoicedTrips ?? InvoicedTripsValue.ALL_TRIPS
  );

  return (
    <RadioGroupFilterPopover
      open={open}
      onClose={onClose}
      triggerElement={<div />}
      label="Invoice"
      value={filterInvoicedTrips}
      onChange={(value) => {
        dispatch(setFilterInvoicedTrips(value));
      }}
      options={[
        {
          label: 'All Trips',
          value: InvoicedTripsValue.ALL_TRIPS,
        },
        {
          label: 'Trips with Invoice',
          value: InvoicedTripsValue.INVOICED_TRIPS,
        },
        {
          label: 'Trips without Invoice',
          value: InvoicedTripsValue.NOT_INVOICED_TRIPS,
        },
        {
          label: 'Trips with Paid Invoice',
          value: InvoicedTripsValue.PAID_INVOICE_TRIPS,
        },
        {
          label: 'Trips with Unpaid Invoice',
          value: InvoicedTripsValue.UNPAID_INVOICE_TRIPS,
        },
      ]}
    />
  );
}
